import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import { t, text, img, pad, date, runtime, showScores } from '../util';
import { startDiscussion } from '../utils/startDiscussion';

/**
 * One episode: still, air date, runtime, score, crew, guest stars and synopsis,
 * with previous / next to move through the season.
 */
export default class EpisodeModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.episode = this.attrs.episode;
  }
  className() {
    return 'MarqueeEpisodeModal Modal--large';
  }
  title() {
    return text('modal.title', {
      season: pad(this.attrs.season.number),
      episode: pad(this.episode.n),
      name: this.episode.title
    });
  }
  content() {
    const {
      link,
      season
    } = this.attrs;
    const e = this.episode;
    const list = season.episodes;
    const index = list.indexOf(e);
    const still = img(e.still, 'w780');
    return [m("div", {
      className: "MarqueeEpisode-still",
      style: still ? {
        backgroundImage: `url(${still})`
      } : undefined
    }, m("span", {
      className: "MarqueeEpisode-badge"
    }, t('modal.badge', {
      title: link.title,
      season: season.number,
      episode: e.n
    }))), m("div", {
      className: "Modal-body MarqueeEpisode-body"
    }, m("ul", {
      className: "MarqueeEpisode-meta"
    }, [date(e.date), runtime(e.runtime)].filter(Boolean).map(part => m("li", null, part)), e.score && showScores() ? m("li", null, m("i", {
      className: "fas fa-star",
      "aria-hidden": "true"
    }), " ", t('modal.score', {
      score: e.score
    })) : null), e.overview ? m("p", {
      className: "MarqueeEpisode-overview"
    }, e.overview) : null, m("dl", {
      className: "MarqueeEpisode-credits"
    }, e.directors.length ? m("div", null, m("dt", null, t('credits.directed_by')), m("dd", null, e.directors.join(', '))) : null, e.writers.length ? m("div", null, m("dt", null, t('credits.written_by')), m("dd", null, e.writers.join(', '))) : null), e.guests.length ? m("div", null, m("h4", {
      className: "MarqueeEpisode-heading"
    }, t('hero.guest_stars')), m("ul", {
      className: "MarqueeEpisode-guests"
    }, e.guests.map(g => m("li", null, g.photo ? m("img", {
      src: img(g.photo, 'w185'),
      alt: "",
      loading: "lazy",
      decoding: "async"
    }) : m("span", {
      className: "Marquee-noPhoto"
    }), m("span", null, m("b", null, g.name), m("small", null, g.role)))))) : null, m("div", {
      className: "MarqueeEpisode-actions"
    }, m(Button, {
      className: "Button",
      icon: "fas fa-chevron-left",
      disabled: index === 0,
      onclick: () => this.episode = list[index - 1]
    }, t('modal.previous')), m(Button, {
      className: "Button",
      icon: "fas fa-chevron-right",
      disabled: index === list.length - 1,
      onclick: () => this.episode = list[index + 1]
    }, t('modal.next')), m("span", {
      className: "MarqueeEpisode-spacer"
    }), m("a", {
      className: "Button",
      href: `${season.url}/episode/${e.n}`,
      target: "_blank",
      rel: "noopener noreferrer"
    }, t('hero.view_on', {
      source: 'TMDB'
    })), app.session.user ? m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-edit",
      onclick: () => {
        app.modal.close();
        startDiscussion({
          ...link,
          season: season.number,
          episode: e
        });
      }
    }, t('modal.discuss_episode')) : null))];
  }
}
flarum.reg.add('ernestdefoe-marquee', 'forum/components/EpisodeModal', EpisodeModal);